import { useShowDebugging } from '~/functions/accounts';
export default defineComponent({
  props: {
    questionnaireComplete: {
      type: Boolean,
      required: true
    },
    incompleteItems: {
      type: Array,
      required: true
    }
  },
  setup: function setup() {
    var showDebugging = useShowDebugging();
    return {
      showDebugging: showDebugging,
      step: 1
    };
  }
});